export default {
  'Form 1065': 'Include only trade or business income and expenses on lines 1a through 22 below. See the instructions for more information',
  'Form 1120S': 'Include only trade or business income and expenses on lines 1a through 21. See the instructions for more information.',
};
